import { supabase } from '@/integrations/supabase/client';

const SUPABASE_URL = "https://nlvqfdktrmrtpmobdwfx.supabase.co";
const GOOGLE_CLIENT_ID = "654591982409-irfkjjc3a6c6ac7ga4tpidjbji6oj5je.apps.googleusercontent.com";

export const SYNC_CALENDAR_REDIRECT = `${SUPABASE_URL}/functions/v1/sync-calendar-auth-callback`;

export function openSyncCalendarAuth() {
  const authUrl = new URL('https://accounts.google.com/o/oauth2/v2/auth');
  authUrl.searchParams.set('client_id', GOOGLE_CLIENT_ID);
  authUrl.searchParams.set('redirect_uri', SYNC_CALENDAR_REDIRECT);
  authUrl.searchParams.set('response_type', 'code');
  authUrl.searchParams.set('scope', 'https://www.googleapis.com/auth/calendar.events https://www.googleapis.com/auth/userinfo.email');
  authUrl.searchParams.set('access_type', 'offline');
  authUrl.searchParams.set('prompt', 'consent');
  window.open(authUrl.toString(), 'sync-calendar-auth', 'width=600,height=700');
}

let pending: ReturnType<typeof setTimeout> | null = null;
let inFlight = false;
let queued = false;

export function triggerSyncCalendar(opts: { delayMs?: number } = {}) {
  const delay = opts.delayMs ?? 1500;
  if (pending) clearTimeout(pending);
  pending = setTimeout(async () => {
    pending = null;
    if (inFlight) { queued = true; return; }
    inFlight = true;
    try {
      const { data, error } = await supabase.functions.invoke('reconcile-sync-calendar');
      if (error) console.warn('[sync-calendar] reconcile error:', error);
      else console.log('[sync-calendar] reconcile result:', data);
    } catch (e) {
      console.warn('[sync-calendar] reconcile exception:', e);
    } finally {
      inFlight = false;
      if (queued) { queued = false; triggerSyncCalendar({ delayMs: 500 }); }
    }
  }, delay);
}
